import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { authGuard } from './auth/auth.guard';
import { LoginComponent } from './login/login.component';
import { PasswordResetComponent } from './login/password-reset/password-reset.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'admin/dashboard',
    // redirectTo: 'backend/chat',

    // admin/orders
    // redirectTo: 'admin/orders-services',
    pathMatch: 'full'
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'reset-password/:token',
    component: PasswordResetComponent
  },
  {
    // localhost:8140/chat/list/14267/27308/campermarkenwelt
    path: 'chat/list/:msgId/:itemId/:company',
    loadChildren: () => import('./chat/admin/admin.module').then(m => m.AdminPageModule),
  },
  {
    path: 'chat/:email/:orderHash',
    loadChildren: () => import('./chat/admin/admin.module').then(m => m.AdminPageModule),
  },
  {
    path: 'chat/id/:itemId/:email/:orderHash',
    loadChildren: () => import('./chat/admin/admin.module').then(m => m.AdminPageModule),
  },
  {
    path: 'chat/admin/:itemId/:email/:orderHash',
    loadChildren: () => import('./chat/admin/admin.module').then(m => m.AdminPageModule),
  },
  {
    path: 'chat/:email/:orderHash/view/:viewMode',
    loadChildren: () => import('./chat/admin/admin.module').then(m => m.AdminPageModule),
  },
  {
    path: 'chat/admin/:itemId/:email/:orderHash/view/:viewMode',
    loadChildren: () => import('./chat/admin/admin.module').then(m => m.AdminPageModule),
  },
  {
    path: 'chat/id/:itemId/:email/:orderHash/view/:viewMode',
    loadChildren: () => import('./chat/admin/admin.module').then(m => m.AdminPageModule),
  },
  {
    path: 'backend/chat',
    loadChildren: () => import('./chat/admin/admin.module').then(m => m.AdminPageModule),
  },
  {
    path: 'backend/chat/t/:tab',
    loadChildren: () => import('./chat/admin/admin.module').then(m => m.AdminPageModule),
  },
  {
    path: 'backend/chat/t/:tab/:timestamp',
    loadChildren: () => import('./chat/admin/admin.module').then(m => m.AdminPageModule),
  },
  {
    path: 'admin/dashboard',
    loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardPageModule),
    canActivate: [authGuard],
    canActivateChild: [authGuard]
  },
  {
    path: 'admin/users',
    loadChildren: () => import('./users/users.module').then(m => m.UsersPageModule),
    canActivate: [authGuard],
    canActivateChild: [authGuard]
  },
  {
    path: 'admin/orders',
    loadChildren: () => import('./orders/orders.module').then(m => m.OrdersPageModule),
    canActivate: [authGuard],
    canActivateChild: [authGuard]
  },
  {
    path: 'admin/settings',
    loadChildren: () => import('./settings/settings.module').then(m => m.SettingsPageModule),
    canActivate: [authGuard],
    canActivateChild: [authGuard]
  },
  {
    path: 'admin/orders-services',
    loadChildren: () => import('./orders-services/orders-services.module').then(m => m.OrdersServicesPageModule),
    canActivate: [authGuard],
    canActivateChild: [authGuard]
  },
  {
    path: 'admin/orders-list',
    loadChildren: () => import('./order-services-list/order-services-list.module').then(m => m.OrderServicesListPageModule),
    canActivate: [authGuard],
    canActivateChild: [authGuard]
  },
  {
    path: 'admin/coupons',
    loadChildren: () => import('./coupons/coupons.module').then(m => m.CouponsPageModule),
    canActivate: [authGuard],
    canActivateChild: [authGuard]
  },
  {
    path: 'admin/chat',
    loadChildren: () => import('./chat/admin/admin.module').then(m => m.AdminPageModule),
    canActivate: [authGuard],
    canActivateChild: [authGuard]
  },
  {
    path: 'admin/customers',
    loadChildren: () => import('./customers/customers.module').then(m => m.CustomersPageModule),
    canActivate: [authGuard],
    canActivateChild: [authGuard]
  },
  {
    path: 'admin/time-log',
    loadChildren: () => import('./time-log/time-log.module').then(m => m.TimeLogPageModule),
    canActivate: [authGuard],
    canActivateChild: [authGuard]
  },
  {
    path: 'admin/request-logs',
    loadChildren: () => import('./request-logs/request-logs.module').then(m => m.RequestLogsPageModule),
    canActivate: [authGuard],
    canActivateChild: [authGuard]
  },
  {
    path: 'admin/access-rights',
    loadChildren: () => import('./access-rights/access-rights.module').then(m => m.AccessRightsPageModule),
    canActivate: [authGuard],
    canActivateChild: [authGuard]
  },
  {
    path: 'admin/logs',
    loadChildren: () => import('./logs/logs.module').then(m => m.LogsPageModule),
    canActivate: [authGuard],
    canActivateChild: [authGuard]
  },
  {
    path: 'admin/monitoring',
    loadChildren: () => import('./monitoring/monitoring.module').then(m => m.MonitoringPageModule),
    canActivate: [authGuard],
    canActivateChild: [authGuard]
  },
  {
    path: 'admin/real-time-monitoring',
    loadChildren: () => import('./real-time-monitoring/real-time-monitoring.module').then(m => m.RealTimeMonitoringPageModule),
    canActivate: [authGuard],
    canActivateChild: [authGuard]
  },
  {
    path: 'admin/locks',
    loadChildren: () => import('./locks/locks.module').then(m => m.LocksPageModule),
    canActivate: [authGuard],
    canActivateChild: [authGuard]
  },
  {
    path: 'admin/translate',
    loadChildren: () => import('./translate/translate.module').then(m => m.TranslatePageModule),
    canActivate: [authGuard],
    canActivateChild: [authGuard]
  },
  {
    path: 'admin/domains',
    loadChildren: () => import('./domains/domains.module').then(m => m.DomainsPageModule),
    canActivate: [authGuard],
    canActivateChild: [authGuard]
  },
  {
    path: 'admin/locations',
    loadChildren: () => import('./locations/locations.module').then(m => m.LocationsPageModule),
    canActivate: [authGuard],
    canActivateChild: [authGuard]
  },
  {
    path: 'admin/franchisees',
    loadChildren: () => import('./franchisees/franchisees.module').then( m => m.FranchiseesPageModule),
    canActivate: [authGuard],
    canActivateChild: [authGuard]
  },
  {
    path: 'statistics',
    loadChildren: () => import('./statistics/statistics.module').then( m => m.StatisticsPageModule)
  },
  {
    path: 'order-services-list',
    loadChildren: () => import('./order-services-list/order-services-list.module').then( m => m.OrderServicesListPageModule)
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
